import React from 'react';

import Showcase from '../components/Showcase';
import CodeFeatureCard from '../components/CodeFeatureCard';

import queries from '../utils/demo-queries';
import mutations from '../utils/demo-mutations';

const examples = [...queries, ...mutations];

const APIShowcase = () => (
  <Showcase items={examples} Component={CodeFeatureCard} layout="vertical" />
);

export default APIShowcase;
